import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { CenteredText, PageHeader } from 'styles/cssComponents';
import { centeredSection } from 'styles/mixins';
import { getResolutionsAndRecomendations } from '../../services/apiService';
import DocList from '../../components/DocList';
import PageImage from 'components/PageImage';

const Wrapper = styled.div`
  ${centeredSection()};
`;

const UchwalyPage = () => {
    const [docs, setDocs] = useState(null);

    useEffect(() => {
        getResolutionsAndRecomendations().then(data => {
            setDocs(data);
        })
    }, [])

    return (
        <>
            <PageImage url='/assets/uchwaly.jpeg'/>
            <Wrapper>
                <PageHeader>Uchwaly / rekomendacje</PageHeader>
                <CenteredText>Konwent WRDPP w wyrażaniu opinii w sprawach istotnych dla funkcjonowania Rad,
                    a także w zakresie współpracy administracji publicznej i organizacji pozarządowych podjął
                    następujące
                    uchwały:</CenteredText>
                <DocList items={docs}/>
            </Wrapper>
        </>
    );
};

export default UchwalyPage;